import { Token } from '@uniswap/sdk-core'
import { SupportedChainId } from 'constants/chains'
import arbTokens from 'constants/tokens/networks/arbitrum'
import fantomTokens from 'constants/tokens/networks/fantom'
import zkTokens from 'constants/tokens/networks/zk-sync'

export const usdGasTokensByChain: { [chainId in SupportedChainId]?: Token[] } = {
  [SupportedChainId.ZK_SYNC]: [zkTokens.usdc, zkTokens.busd],
  [SupportedChainId.FANTOM]: [fantomTokens.dai, fantomTokens.frax, fantomTokens.usdc, fantomTokens.usdt],
  [SupportedChainId.ARBITRUM]: [arbTokens.usdc],
}
